<template>
  <div class="proposeList">
    <Gengduo
        v-if="showMenu"
        :hideMenu="hideMenu"
        @getNft="getNft"
        :timer="timer"
        :show_address="show_address"
        @getWorth="getWorth"
        :mobilityBase="mobility"
    ></Gengduo>
    <div class="pone">
      <img
          src="@/assets/c/icon_cgd.png"
          class="icon_cgd"
          alt=""
          @click="showMenu = true"
      />
      <span class="wel">Welcomel</span>
      <img
          src="@/assets/c/icon_qb.png"
          @click="setWalletPopupState()"
          class="icon_qb"
          alt=""
      />
    </div>
    <div class="ptwo">
      <img src="@/assets/c/img_bj.png" class="img_bj" alt=""/>
      <div class="ptview">
        <div class="pthead">
          <img
              src="@/assets/c/icon_logo.png"
              class="icon_logo"
              alt=""
          />
          <span class="pnum" style="padding-top: 3px">{{
              show_address
            }}</span>
        </div>
        <div class="pnav">
          <div class="navone">
            <span class="chiname">{{ $t("new.chijia") }}</span>
            <img
                src="@/assets/c/icon_wh.png"
                @click="setJiaShow()"
                class="icon_wh"
                alt=""
            />
            <span class="cms">GMC</span>
          </div>
          <div class="navone">
                        <span class="chinum"
                        >{{ gmc_balance_total_show }}
                        </span>
            <span class="numstwo">
                            ≈ ${{ gmc_balance_about_total_show }}</span
            >
            <!-- <span
                class="cms animate__animated animate__bounceIn"
                style="animation-duration: 2s"
                >${{ gmc_price }}</span
            > -->
            <span class="cms" style="animation-duration: 2s"
            >${{ gmc_price_show }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="pthree">
      <div class="ptview" @click="getnav(1)">
        <img src="@/assets/c/icon_sm.png" class="icon_sm" alt=""/>
        <span class="pname">{{ $t("new.hone") }}</span>
      </div>
      <div class="ptview" @click="getnav(2)">
        <img src="@/assets/c/icon_sk.png" class="icon_sm" alt=""/>
        <span class="pname">{{ $t("new.htwo") }}</span>
      </div>
      <div class="ptview" @click="getnav(3)">
        <img src="@/assets/c/icon_fk.png" class="icon_sm" alt=""/>
        <span class="pname">{{ $t("new.hthree") }}</span>
      </div>
      <div class="ptview" @click="getnav(4)">
        <img src="@/assets/c/icon_kt.png" class="icon_sm" alt=""/>
        <span class="pname">{{ $t("new.hfour") }}</span>
      </div>
      <div class="ptview" @click="getnav(5)">
        <img src="@/assets/c/icon_jd.png" class="icon_sm" alt=""/>
        <span class="pname">{{ $t("new.hfive") }}</span>
      </div>
      <div class="ptview" @click="getnav(6)">
        <img src="@/assets/c/icon_ico.png" class="icon_sm" alt=""/>
        <span class="pname">ICO</span>
      </div>
      <div class="ptview" @click="getnav(7)">
        <img src="@/assets/c/icon_nft.png" class="icon_sm" alt=""/>
        <span class="pname">NFT</span>
      </div>
      <div class="ptview" @click="getnav(8)">
        <img src="@/assets/c/icon_gd.png" class="icon_sm" alt=""/>
        <span class="pname">{{ $t("new.hsix") }}</span>
      </div>
    </div>
    <div class="pfour">
      <span class="pfname">Galmcypro NFT</span>
      <!-- <div class="phua">
          <div
              class="huaview"
              v-for="(item, index) in nftList"
              :key="index"
              @click="gongdetail(item.id)"
          >
              <img :src="item.thumbnail" class="img_hyshnft" alt="" />
              <div class="huabot">
                  <span class="heyue">{{ item.name }}</span>
                  <span class="hemiao">{{ item.synopsis }}</span>
                  <div class="henum">
                      <span class="price">${{ item.price }}</span>
                      <div class="gou">{{ $t("new.gname") }}</div>
                  </div>
              </div>
          </div>
      </div> -->

      <HomeSwiper :nftList="nftList"/>
    </div>
    <div class="pfive" @click="gonglist">
      <span class="gname">{{ $t("new.gzhongx") }}</span>
      <img src="@/assets/c/icon_jr.png" class="icon_jr" alt=""/>
    </div>
    <div class="pfive flexcol">
      <span class="gname mb">{{ $t("new.yaozhongx") }}</span>
      <div class="yaoview" @click="getyao">
        <img src="@/assets/c/img_yqhy.png" class="img_yqhy" alt=""/>
        <div class="yaoitem">
          <span class="ybiao">{{ $t("new.yaoname") }}</span>
          <span class="yaoying">Invite friends</span>
          <span class="ybiaode">{{ $t("new.dexian") }}</span>
          <span class="yaoying">Get more rewards</span>
        </div>
      </div>
    </div>

    <van-popup
        :close-on-click-overlay="false"
        v-model="jiashow"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.4)' }"
    >
      <div class="van-popview animate__animated animate__zoomIn">
        <div class="jiahead">
          <img src="@/assets/c/img_btbj.png" class="bg" alt=""/>
          <div class="jiaview">
            {{ $t("new.jiaxs") }}
          </div>
        </div>
        <div class="biaoview">
          <div
              class="bmiao"
              v-html="rule"
              style="font-size: 13px"
          ></div>
        </div>
        <div
            class="zhixiao"
            @touchmove.prevent
            @click.stop="jiashow = false"
        >
          {{ $t("new.zhixiao") }}
        </div>
      </div>
    </van-popup>

    <van-popup
        :close-on-click-overlay="false"
        v-model="showPopup"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.4)' }"
    >
      <div class="popviewnew animate__animated animate__zoomIn">
        <img src="@/assets/c/img_tcbjpop.png" class="bg" alt=""/>
        <div class="btitem">
          <div class="bilogo">
            <img
                src="@/assets/c/img_logopop.png"
                class="img_logopop"
                alt=""
            />
          </div>
          <div class="biaoview">
            <span class="bname">{{ homepopup_title }}</span>
            <div class="bmiao" v-html="homepopup_rule"></div>
          </div>
          <div @click="hidePopup()" class="zhiview">
            <img
                src="@/assets/c/img_anbjpop.png"
                class="bg"
                alt=""
            />
            <div class="zhiitems">
              {{ $t("new.zhixiao") }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 链接弹窗 -->
    <van-popup
        :close-on-click-overlay="false"
        v-model="walletPopupState"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.4)' }"
    >
      <div
          class="animate__animated animate__zoomIn wallet-popup"
          style=""
      >
        <img src="@/assets/c/pbtntwo.png" class="bg" alt=""/>
        <div class="jdview">
          <div class="jshead">
            <img src="@/assets/c/pbtnone.png" class="bg" alt=""/>
            <div class="jheadview">WALLET</div>
          </div>
          <div class="wallet-list">
            <div class="wallet-item" @click="enableLogin">
              <img
                  src="@/assets/wallet-icon/MetaMask.png"
                  class="wallet-bg"
                  alt=""
              />
              <div>MetaMask</div>
            </div>
            <div class="wallet-item" @click="enableLogin">
              <img
                  src="@/assets/wallet-icon/TokenPocket.png"
                  class="wallet-bg"
                  alt=""
              />
              <div>TokenPocket</div>
            </div>
            <div class="wallet-item" @click="enableLogin">
              <img
                  src="@/assets/wallet-icon/TrustWallet.png"
                  class="wallet-bg"
                  alt=""
              />
              <div>TrustWallet</div>
            </div>
            <div class="wallet-item" @click="enableLogin">
              <img
                  src="@/assets/wallet-icon/WalletConnect.png"
                  class="wallet-bg"
                  alt=""
              />
              <div>WalletConnect</div>
            </div>

            <div class="wallet-item" @click="enableLogin">
              <img
                  src="@/assets/wallet-icon/Coinbase.png"
                  class="wallet-bg"
                  alt=""
              />
              <div>Coinbase</div>
            </div>
          </div>
          <div
              class="jsheadbot"
              @click.stop="walletPopupState = false"
          >
            <img src="@/assets/c/pbtnthree.png" class="bg" alt=""/>
            <div class="jheadview">Close</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {showToast} from "@/libs/util.js";
import {ajaxData} from "@/api/ajax";
import {useNumberAnimation} from "@/libs/util.js";
import Gengduo from "@/view/Cview/Gengduo.vue";
import HomeSwiper from "@/view/components/HomeSwipe.vue";

import InvestAbi from "@/abi/Invest-abi.json";
import {CoinContract} from "@/libs/Contract.js";

import {INVEST_ADDRESS} from "@/libs/ContractAddress.js";
import {setToken, getToken} from "@/libs/util";
import {add, mul, countDecimalPlaces} from "@/libs/math.js";
import Web3 from "web3";

export default {
  components: {
    Gengduo,
    HomeSwiper,
  },
  data() {
    return {
      timer: "",
      show_address: "",
      checkAddress: "",
      timerInterval: "",
      jiashow: false,
      btshow: false,
      showMenu: false,
      gmc_price_show: 0,
      gmc_balance_show: 0,
      gmc_balance_total: 0,
      gmc_balance_total_show: 0,
      gmc_balance_about_total: 0,
      gmc_balance_about_total_show: 0,
      showPopup: true,
      walletPopupState: false,
      rule: "",
      invite: "0x0000000000000000000000000000000000000000",
      address: "",
      homepopup_rule: "",
      homepopup_title: "",
      gmc_balance: "0",
      gmc_balance_about: "0",
      gmc_price: "",
      nft: [],
      web3Provider: null,
      web3: null,
      mobility: 0,
    };
  },
  computed: mapState(["nftList"]),
  created() {
    this.init();
    const is_show = window.sessionStorage.getItem("hidePopup");
    console.log("is_show", is_show);
    if (is_show) {
      this.showPopup = false;
    }
    if (localStorage.getItem("homeMenu")) {
      this.showMenu = true;
      localStorage.removeItem("homeMenu");
    }
  },
  deactivated() {
    clearInterval(this.timerInterval);
  },
  mounted() {
    // this.gmc_price = 0.0;x
    this.timerInterval = setInterval(this.updateTime, 1000);
    // if (this.gmc_balance > 0) {
    //     useNumberAnimation(this.gmc_balance, (num) => {
    //         this.gmc_balance_show = num;
    //     });
    // }

    // if (this.gmc_balance_about > 0) {
    //     useNumberAnimation(this.gmc_balance_about, (num) => {
    //         this.gmc_balance_about_show = num?.toFixed(2);
    //     });
    // }

    // if (this.gmc_price > 0) {
    //     useNumberAnimation(this.gmc_price, (num) => {
    //         this.gmc_price_show = num?.toFixed(2);
    //     });
    // }
  },
  watch: {
    gmc_balance(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_show = num?.toFixed(2);
        });
      }
    },
    gmc_balance_about(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_about_show = num;
        });
      }
    },
    gmc_price(newVal) {
      if (newVal > 0) {
        let count = countDecimalPlaces(newVal);
        useNumberAnimation(newVal, (num) => {
          this.gmc_price_show = num?.toFixed(count);
        });
      }
    },
    gmc_balance_total(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_total_show = num.toFixed(2);
          // this.gmc_price_show = num?.toFixed(2);
        });
      }
    },
    gmc_balance_about_total(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_about_total_show = num.toFixed(2);
          // this.gmc_price_show = num?.toFixed(2);
        });
      }
    },
    address(newVal) {
      console.log(newVal);
      if (newVal != "") {
        try {
          this.show_address =
              newVal.substr(0, 12) +
              `*****` +
              newVal.substr(newVal.length - 12, 12);
        } catch (e) {
        }
      }
    },
  },
  methods: {
    ...mapActions["setNft"],
    updateTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      this.timer =
          `${year}-${month}-${day} ` +
          hours.toString().padStart(2, "0") +
          ":" +
          minutes.toString().padStart(2, "0") +
          ":" +
          seconds.toString().padStart(2, "0");
    },
    async init() {
      let vm = this;
      if (sessionStorage.getItem("address")) {
        this.address = sessionStorage.getItem("address");
      }
      this.setting();
      this.getNotice();
      this.getNft();
      // 1.
      if (window.ethereum) {
        vm.web3Provider = window.ethereum;
        vm.web3 = new Web3(vm.web3Provider);
        vm.checkAddress = ethereum.selectedAddress;
      }
      console.log(window.ethereum, vm.web3, ethereum.selectedAddress)

      console.log(
          vm.checkAddress,
          "vm.checkAddress",
          ethereum.selectedAddress
      );
      if (vm.$route.query.invite != undefined) {
        vm.invite = vm.$route.query.invite;
      }
      let token = getToken();
      console.log(token, "111111111111");
      if (token) {
        this.getUser();
      } else {
        await vm.enable();
      }
    },

    async enable() {
      let vm = this;
      if (sessionStorage.getItem("isLogin")) return;

      // this.invite_contract();
      // let token = getToken()
      // token = false
      // if (token == false){
      // }else{
      //     vm.getUser()
      //     console.log(token)
      // }
      let isRegister = await vm.isCheckUser();
      console.log(isRegister, "isRegister");
      if (!isRegister) {
        this.invite_contract();
        return;
      }
      let tokens = getToken();
      if (!tokens) {
        vm.web3Provider
            .enable() //如果用户拒绝了登录请求
            .catch(function (reason) {
              console.log("reason");
              if (reason === "User rejected provider access") {
                showToast("用户拒绝提供程序访问");
              } else {
                // 本不该执行到这里，但是真到这里了，说明发生了意外
                showToast("请刷新重试");
              }
            })
            //如果用户同意了登录请求，你就可以拿到用户的账号
            .then(function (accounts) {
              console.log("-----");
              // alert(ethereum.selectedAddress)
              // You also should verify the user is on the correct network:
              //你也可以验证用户接入了正确的网络
              if (
                  vm.web3Provider.networkVersion !== vm.desiredNetwork
              ) {
                // layer_msg('请选择正确的网络.')
                //我们计划在最近补充一个有关网络切换的API，参考下面链接
                // https://github.com/MetaMask/metamask-extension/issues/3663
              }
              //一旦获取了用户账号，你就可以签名交易
              console.log(accounts);

              let address = ethereum.selectedAddress;
              address = address.toLowerCase();
              let toastStr = `Welcome to Galmcypro, start explore right now！Click "Sign" to sign in.  No password needed！

Wallet address:
${address}`;
              // let toastStr = "login";
              console.log("selectaddress:" + address);
              let token = getToken();
              if (token == false) {
                console.log(1111111111111);
                vm.web3.eth.personal.sign(
                    vm.web3.utils.utf8ToHex(toastStr),
                    address,
                    (err, sign) => {
                      console.log(err, sign);
                      if (err) {
                        console.log("111", err);
                        showToast(vm.$t("請重新鏈接錢包"));
                      } else {
                        console.log(address, vm.invite);
                        ajaxData("/login", {
                          address: address,
                          invite: vm.invite,
                        }).then((response) => {
                          console.log(response, 111111111111);

                          sessionStorage.setItem(
                              "isLogin",
                              true
                          );
                          setToken(response.data.token);
                          showToast(vm.$t("已成功鏈接錢包"));

                          vm.getUser();
                        });
                        // }else {
                        //     vm.getUser()
                        // }
                      }
                    }
                );
              }
            });
      } else {
        vm.getUser();
      }
    },
    setting() {
      let vm = this;
      ajaxData("/setting", {}).then((response) => {
        vm.notice = response.data.setting.notice;
        vm.synopsis = response.data.setting.synopsis;
        vm.rotation = response.data.rotation;
        vm.gmc_price = parseFloat(response.data.setting.gmc_price);
        this.mobility = parseFloat(response.data.setting.mobility);
      });
    },
    getNotice() {
      let vm = this;
      ajaxData("/setting", {key: "homepopup"}).then((response) => {
        if (localStorage.getItem("locale") == "zh") {
          vm.homepopup_rule = response.data.setting.rule;
          vm.homepopup_title = response.data.setting.title;
        } else {
          vm.homepopup_rule = response.data.setting.rule_en;
          vm.homepopup_title = response.data.setting.title_en;
        }
      });
    },
    getNft() {
      let vm = this;
      this.$store.dispatch("setNft");
    },
    getUser() {
      let vm = this;
      ajaxData("/user/info", {})
          .then((response) => {
            this.address = ethereum.selectedAddress;
            sessionStorage.setItem("address", this.address);
            let user = response.data.user;
            vm.gmc_price = parseFloat(response.data.gmc_price);
            vm.gmc_balance = response.data.gmc_balance;
            vm.gmc_balance_about = response.data.gmc_balance_about;
            vm.crowd_funding = user.crowd_funding;
            vm.gmc_balance_total = add(
                response.data.gmc_balance,
                response.data.gmc_balance_lock
            );
            vm.gmc_balance_about_total = mul(
                vm.gmc_balance_total,
                response.data.gmc_price
            );
            console.log("地址", user.address != vm.address);
          })
          .catch((e) => {
          });
    },
    // 校验是否注册过
    async isCheckUser() {
      let res = await ajaxData("/check", {
        address: this.checkAddress,
      });
      if (res.code == 0) {
        return res.data?.result;
      }
    },
    hidePopup() {
      this.showPopup = false;
      window.sessionStorage.setItem("hidePopup", true);
    },
    hideMenu() {
      this.showMenu = false;
    },
    goHome() {
      this.$router.go(-1);
    },
    getnav(e) {
      if (e == 1) {
        //收款
        this.$router.push({path: "/Scan"});
      } else if (e == 2) {
        //收款
        this.$router.push({path: "/Shoukuan"});
      } else if (e == 3) {
        //付款
        this.$router.push({path: "/Fukuan"});
      } else if (e == 8) {
        //更多
        this.$router.push({path: "/Glist"});
      } else if (e == 7) {
        //NFT
        this.$router.push({path: "/NFT"});
      } else if (e == 4) {
        //空投
        this.$router.push({path: "/Kongtou"});
      } else if (e == 5) {
        //节点
        this.$router.push({path: "/node"});
      } else if (e == 6) {
        //ico
        this.$router.push({path: "/ico"});
      }
    },
    getScan() {
      this.$router.push({path: "/Scan"});
    },
    getyao() {
      this.$router.push({path: "/Yaoqing"});
    },
    gonglist() {
      this.$router.push({path: "/Gonglist"});
    },
    gongdetail(id) {
      this.$router.push({path: "/NFTDetail?id=" + id});
    },
    setJiaShow() {
      this.jiashow = true;
      this.getWorth();
    },
    getWorth() {
      let vm = this;
      ajaxData("/setting", {key: "worth"}).then((response) => {
        console.log(response);
        vm.rule = response.data.setting.rule;
        if (localStorage.getItem("locale") == "en") {
          vm.rule = response.data.setting.rule_en;
        }
      });
    },
    setWalletPopupState() {
      if (sessionStorage.getItem("isLagout") == 1 || !getToken()) {
        this.walletPopupState = true;
      }
    },
    async enableLogin() {
      this.walletPopupState = false;

      let vm = this;
      if (window.ethereum) {
        vm.web3Provider = window.ethereum;
        vm.web3 = new Web3(vm.web3Provider);
        vm.address = vm.web3Provider.selectedAddress;

        // let token = getToken()
        // token = false
        // if (token == false){
        // }else{
        //     vm.getUser()
        //     console.log(token)
        // }
      }
      let isRegister = await vm.isCheckUser();
      console.log(isRegister, "isRegister");
      if (!isRegister) {
        this.invite_contract();
        return;
      }
      vm.web3Provider
          .enable() //如果用户拒绝了登录请求
          .catch(function (reason) {
            console.log("reason");
            if (reason === "User rejected provider access") {
              showToast("用户拒绝提供程序访问");
            } else {
              // 本不该执行到这里，但是真到这里了，说明发生了意外
              showToast(vm.$t('execute_connect_wallet'));
            }
          })
          //如果用户同意了登录请求，你就可以拿到用户的账号
          .then(function (accounts) {
            console.log("-----");
            // alert(ethereum.selectedAddress)
            // You also should verify the user is on the correct network:
            //你也可以验证用户接入了正确的网络
            if (vm.web3Provider.networkVersion !== vm.desiredNetwork) {
              // layer_msg('请选择正确的网络.')
              //我们计划在最近补充一个有关网络切换的API，参考下面链接
              // https://github.com/MetaMask/metamask-extension/issues/3663
            }
            //一旦获取了用户账号，你就可以签名交易
            console.log(accounts);

            let address = vm.web3Provider.selectedAddress;
            address = address.toLowerCase();
            let toastStr = `Welcome to Galmcypro, start explore right now！Click "Sign" to sign in.  No password needed！

Wallet address:
${address}`;
            // let toastStr = "login";
            console.log("selectaddress:" + vm.address);

            console.log(1111111111111);
            vm.web3.eth.personal.sign(
                vm.web3.utils.utf8ToHex(toastStr),
                address,
                (err, sign) => {
                  console.log(err, sign);
                  if (err) {
                    console.log("111", err);
                    showToast(vm.$t('relink_wallet'));
                  } else {
                    console.log(address, vm.invite);
                    ajaxData("/login", {
                      address: address,
                    }).then((response) => {
                      showToast(vm.$t("已成功鏈接錢包"));
                      console.log(response);
                      setToken(response.data.token);
                      vm.getUser();
                    });
                    // }else {
                    //     vm.getUser()
                    // }
                  }
                }
            );
          }).catch((e) => {
        showToast(vm.$t('execute_connect_wallet'));
      })
    },
    // 注册业务
    async invite_contract() {
      let vm = this;
      let contract = new CoinContract(InvestAbi, INVEST_ADDRESS);
      console.log("contract", contract);
      // vm.invite = "0x8708b44673088871b8A03A81Af1f999ba0e0fF1b";
      try {
        let invite_result = await contract.bindIntro(vm.invite);
        console.log("result", invite_result);
        if (invite_result) {
          ajaxData("/register", {
            address: ethereum.selectedAddress,
            invite: vm.invite,
          }).then((response) => {
            console.log(response);
            setToken(response.data.token);
            vm.getUser();
          });
        }
      } catch (e) {
        console.error("错误内容:", e);
      }
    },
  },
};
</script>

<style scoped lang="less">
p {
  margin: 0;
  padding: 0;
}

body,
html {
  overflow-x: hidden;
}

::-webkit-scrollbar {
  display: none;
}

// html { overflow-y:hidden; }

.proposeList {
  width: 100%;
  padding-bottom: 70px;
  background: #f3f5f8;

  .pone {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px;

    .icon_cgd {
      width: 25px;
      height: 25px;
      margin-right: 9px;
    }

    .wel {
      font-weight: bold;
      font-size: 19px;
      color: #111111;
    }

    .icon_qb {
      margin-left: auto;
      width: 22px;
      height: 22px;
    }
  }

  .ptwo {
    margin: 0px 10px 10px;
    height: 140px;
    position: relative;

    .img_bj {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .ptview {
      position: relative;
      display: flex;
      flex-direction: column;

      .pthead {
        height: 50px;
        background: #26e7fe;
        border-radius: 20px;
        display: flex;
        align-items: center;
        padding: 0 15px;

        .icon_logo {
          width: 22px;
          margin-right: 7px;
          height: 22px;
        }

        .pnum {
          font-weight: bold;
          font-size: 16px;
          color: #000000;
        }
      }

      .pnav {
        display: flex;
        flex-direction: column;
        padding: 15px 25px;

        .navone {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 5px;

          .icon_wh {
            width: 7px;
            height: 7px;
            margin-left: 3px;
            position: relative;
            top: -3px;
          }

          .chiname {
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
          }

          .cms {
            margin-left: auto;
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 14px;
            color: #26e7fe;
          }

          .chinum {
            font-weight: bold;
            font-size: 20px;
            color: #ffffff;
          }

          .numstwo {
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            display: inline-block;
            margin-left: 4px;
          }
        }
      }
    }
  }

  .pthree {
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .ptview {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;

      .icon_sm {
        width: 65px;
        height: 65px;
        margin-bottom: 6px;
      }

      .pname {
        font-weight: 500;
        font-size: 13px;
        color: #1a1a1a;
      }
    }
  }

  .pfour {
    margin: 0 20px;

    .pfname {
      font-weight: bold;
      font-size: 14px;
      color: #1a1a1a;
      display: block;
      margin-bottom: 15px;
    }

    .phua {
      // width: 100vh;
      position: relative;
      white-space: nowrap;
      overflow-x: auto;

      .huaview {
        width: 260px;
        // height: 190px;
        background: #ffffff;
        border-radius: 20px;
        margin-right: 15px;
        padding: 0 0;
        display: inline-block;

        .img_hyshnft {
          width: 100%;
          height: 110px;
          border-radius: 20px;
        }

        .huabot {
          padding: 10px 10px;
          display: flex;
          flex-direction: column;

          .heyue {
            font-weight: bold;
            font-size: 14px;
            color: #1a1a1a;
          }

          .hemiao {
            font-weight: 400;
            font-size: 10px;
            color: #999999;
            display: block;
            margin: 2px 0 2px;
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            height: 30px;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .henum {
            display: flex;
            flex-direction: row;
            align-items: center;

            .price {
              font-weight: bold;
              font-size: 15px;
              color: #1a1a1a;
            }
          }

          .gou {
            margin-left: auto;
            width: 60px;
            height: 24px;
            background: #1a1a1a;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 13px;
            color: #ffffff;
          }
        }
      }
    }
  }

  .header {
    height: 50px;
    // margin-bottom: 12px;
    // padding: 40px 12px 0 12px;
    padding: 6px;
    box-sizing: border-box;
    background: rgba(52, 56, 75, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    width: 100%;
    z-index: 10;
    top: 0;

    img {
      width: 55px;
      height: 55px;
      position: absolute;
      left: 10px;
    }

    span {
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .pfive {
    margin: 15px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .icon_jr {
      margin-left: auto;
      width: 14px;
      height: 14px;
    }
  }

  .gname {
    display: block;
    font-weight: bold;
    font-size: 14px;
    color: #1a1a1a;
  }

  .yaoview {
    height: 120px;
    width: 100%;
    position: relative;

    .img_yqhy {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .yaoitem {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 22px 25px;
      display: flex;
      flex-direction: column;

      .ybiao {
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
        line-height: 25px;
      }

      .yaoying {
        font-weight: 300;
        font-size: 10px;
        color: #ffffff;
      }

      .ybiaode {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        display: block;
        margin-top: 5px;
      }
    }
  }

  .mb {
    margin-bottom: 12px;
    display: block;
  }

  .flexcol {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .mhead {
    // position: relative;
    // top: 50px;
  }
}

.van-popview {
  position: relative;
  width: 330px;
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid #26e7fe;
  padding: 10px 30px 20px;

  .jiahead {
    width: 104px;
    height: 37px;
    position: relative;
    margin: 0 auto;

    .jiaview {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 15px;
      color: #1a1a1a;
    }
  }

  .biaoview {
    display: flex;
    flex-direction: column;
    margin: 10px 0;

    .bname {
      width: 100%;
      display: block;
      text-align: center;
      font-weight: 500;
      font-size: 18px;
      // color: #26e7fe;
      color: #1a1a1a;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .bmiao {
      font-weight: 500;

      height: 110px;
      font-size: 10px;
      // color: #26e7fe;
      color: #1a1a1a;
      max-height: 170px;
      overflow: scroll;
    }
  }

  .zhixiao {
    width: 100%;
    height: 44px;
    background: #26e7fe;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #1a1a1a;
  }
}

.popviewnew {
  width: 330px;
  position: relative;

  .btitem {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .bilogo {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .img_logopop {
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }

    .biaoview {
      display: flex;
      flex-direction: column;
      margin: 10px 20px 29px;

      .bname {
        width: 100%;
        display: block;
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        // color: #26e7fe;
        color: #1a1a1a;
        font-weight: bold;
        margin-bottom: 15px;
      }

      .bmiao {
        font-weight: 500;

        height: 135px;
        font-size: 10px;
        // color: #26e7fe;
        color: #1a1a1a;
        max-height: 170px;
        overflow: scroll;
      }
    }

    .zhiview {
      // margin-top: auto;
      width: 110px;
      position: relative;
      height: 39px;
      margin: auto auto 30px;

      .zhiitems {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        color: #1a1a1a;
      }
    }
  }
}

.wallet-popup {
  position: relative;
  padding: 0;
  width: 300px;
  border: 1px solid #26e7fe;
  background: transparent !important;

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .jdview {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;

    .guiname {
      color: #00ffff;
    }

    .jshead {
      position: relative;
      width: 103px;
      height: 37px;
      margin: 15px auto;

      .jheadview {
        position: relative;
        width: 100%;
        height: 100%;
        font-weight: bold;
        font-size: 16px;
        color: #00ffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .jsheadbot {
      width: 150px;
      height: 54px;
      position: relative;
      margin: 10px auto 20px;

      .jheadview {
        position: relative;
        width: 100%;
        height: 100%;
        font-weight: bold;
        font-size: 14px;
        color: #00ffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .wallet-list {
    width: 100%;

    .wallet-item {
      position: relative;
      width: 100%;
      height: 50px;
      margin-bottom: 5px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      overflow: hidden;

      .wallet-bg {
        position: absolute;
        width: 100%;
      }

      > div {
        position: relative;
        color: #fff;
        font-size: 16px;
        width: 100%;
        padding-left: 55px;
      }
    }
  }
}
</style>
